export default function ReviewHero() {
  return (
    <section className="relative w-full overflow-hidden" style={{ minHeight: '380px' }}>
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20and%20cozy%20hospital%20room%20with%20soft%20natural%20light%20coming%20through%20large%20windows%20gentle%20beige%20and%20cream%20tones%20minimalist%20interior%20calm%20healing%20atmosphere%20clean%20white%20walls%20subtle%20green%20plant%20accents%20peaceful%20recovery%20space&width=1440&height=380&seq=review-hero-01&orientation=landscape"
          alt="고객 후기"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      <div className="relative z-10 flex flex-col items-center justify-center text-center w-full px-6 py-24 md:py-32">
        <p className="text-xs font-semibold tracking-widest uppercase mb-4 text-white/70">CUSTOMER REVIEWS</p>
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
          고객님들의 생생한 후기
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
          코리아케어러스를 이용하신 고객님들의 실제 경험을<br className="hidden md:block" />
          솔직하게 전달드립니다.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <div className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 flex items-center gap-2">
            <i className="ri-star-fill text-yellow-400 text-sm"></i>
            <span className="text-white text-sm font-semibold">평균 평점 4.9</span>
          </div>
          <div className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 flex items-center gap-2">
            <i className="ri-chat-heart-line text-[#6ECFBD] text-sm"></i>
            <span className="text-white text-sm font-semibold">누적 후기 500+</span>
          </div>
          <div className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 flex items-center gap-2">
            <i className="ri-user-heart-line text-[#6ECFBD] text-sm"></i>
            <span className="text-white text-sm font-semibold">재이용율 92%</span>
          </div>
        </div>
      </div>
    </section>
  );
}
